import { render, staticRenderFns } from "./MdCase.vue?vue&type=template&id=e781ca98&scoped=true&"
import script from "./MdCase.vue?vue&type=script&lang=js&"
export * from "./MdCase.vue?vue&type=script&lang=js&"
import style0 from "./MdCase.vue?vue&type=style&index=0&id=e781ca98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e781ca98",
  null
  
)

export default component.exports